import React from 'react';
import { ExternalLinkDetailsFormTemplate } from './ExternalLinkDetailsFormTemplate';
import Form from '../../../molecules/Form';
import { RefreshCallback } from '../../../../_lib/FetchContainer';
import IForm from '../../../../types/IForm';

export type ExternalLinkDetailsFormProps = {
  refreshBlock: RefreshCallback;
  form: IForm;
};

export function ExternalLinkDetailsForm({ refreshBlock, form }: ExternalLinkDetailsFormProps) {
  const onSuccess = () => setTimeout(refreshBlock, 2000);
  return (
    <Form
      id="external-link-details-update-form"
      model={{
        url: form.url,
        params: form.params,
      }}
      action={form.url}
      onSuccess={onSuccess}
    >
      <ExternalLinkDetailsFormTemplate />
    </Form>
  );
}
